import { AfterContentInit, Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { detect } from 'detect-browser';
import * as moment from 'moment';
import 'moment/locale/fr';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { ENavigationRoute } from './model/enum/navigation-route';
const browser = detect();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements AfterContentInit {
    @ViewChild(NavMenuComponent) menu: NavMenuComponent;
    @ViewChild('tata', { read: ElementRef }) mainContainer: ElementRef;
    title = 'DeuMeuTra';
    PageHeight;
    Overflow;

    constructor(
        private router: Router) {
        moment.locale('fr');
    }

    ngAfterContentInit(): void {
        this.PageHeight = `calc(100% - 80px)`;
        this.Overflow = 'auto';

        if (browser && browser.name === 'ie') {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.IE }]);
        }
    }

    updateHeight(event) {
        this.Overflow = 'hidden';
        setTimeout(() => {
            this.PageHeight = `calc(100% - ${event})`;
            this.Overflow = 'auto';
        }, 0);
    }
}
